import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getOurStorage, deleteOurStorage } from '../../../api/storage'
import { useCan } from '../../../hooks/useCan';
import { SLUGS } from '../../../enum/permissions.enum';

export default function Storage(props) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='storage'
      title='Список складов'
      columns={[
        { id: 'name', name: 'Наименование' },
        { id: 'address', name: 'Адрес' },
      ]}
      createItem={can(SLUGS.STORAGE.MANAGE)}
      deleteItem={can(SLUGS.STORAGE.MANAGE)}
      loadAPI={{
        request: getOurStorage,
      }}
      click={can(SLUGS.STORAGE.MANAGE)}
      deleteAPI={deleteOurStorage}
      {...props}
    />
  </div>
}


